import { useRef, useState } from 'react';
import { useEffect } from 'react';

export const useVideosLayout = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  const getGridSize = (width: number) => {
    if (width < 250) return 12;
    if (width < 400) return 6;
    return 4;
  };

  return { containerRef, containerWidth, getGridSize };
};
